export interface Comic {
  id: number;
  title: string;
  author: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  description: string;
  rating: number;
  views: number;
  chapters: number;
  status: '连载中' | '已完结';
  updatedAt: string;
  tags: string[];
}

export interface Category {
  name: string;
  slug: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  { name: '恋爱', slug: 'romance', icon: 'ri-heart-line', count: 128 },
  { name: '悬疑', slug: 'thriller', icon: 'ri-search-eye-line', count: 86 },
  { name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line', count: 95 },
  { name: '校园', slug: 'school', icon: 'ri-book-open-line', count: 112 },
  { name: '动作', slug: 'action', icon: 'ri-flashlight-line', count: 73 },
  { name: '喜剧', slug: 'comedy', icon: 'ri-emotion-laugh-line', count: 64 },
  { name: '剧情', slug: 'drama', icon: 'ri-film-line', count: 91 },
  { name: '恐怖', slug: 'horror', icon: 'ri-ghost-line', count: 47 },
];

export const featuredComics: Comic[] = [
  {
    id: 1,
    title: '我的野蛮女友',
    author: '金惠敏',
    category: '恋爱',
    categorySlug: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20romantic%20couple%20in%20soft%20pastel%20colors%2C%20cherry%20blossom%20background%2C%20gentle%20lighting%2C%20clean%20composition%2C%20manhwa%20cover%20art%20style%2C%20warm%20and%20sweet%20atmosphere%2C%20soft%20edges%2C%20korean%20webtoon%20aesthetic&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '一段跨越国界的浪漫爱情故事，霸道总裁与普通女孩的甜蜜邂逅，带你感受最纯粹的恋爱滋味。',
    rating: 4.8,
    views: 1280000,
    chapters: 156,
    status: '连载中',
    updatedAt: '2026-08-07',
    tags: ['恋爱', '总裁', '甜宠'],
  },
  {
    id: 2,
    title: '暗夜追踪者',
    author: '朴志勋',
    category: '悬疑',
    categorySlug: 'thriller',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20mystery%20Korean%20manhwa%20cover%20illustration%20with%20a%20detective%20in%20trench%20coat%20standing%20in%20rainy%20alley%2C%20noir%20atmosphere%2C%20dramatic%20shadows%2C%20cool%20blue%20and%20dark%20tones%2C%20suspenseful%20mood%2C%20clean%20manhwa%20art%20style%2C%20korean%20webtoon%20aesthetic&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '连环杀人案背后的惊天秘密，天才侦探与神秘组织的智力对决，每一页都让你屏住呼吸。',
    rating: 4.9,
    views: 980000,
    chapters: 89,
    status: '连载中',
    updatedAt: '2026-08-06',
    tags: ['悬疑', '推理', '犯罪'],
  },
  {
    id: 3,
    title: '异界魔法学院',
    author: '李秀妍',
    category: '奇幻',
    categorySlug: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20fantasy%20Korean%20manhwa%20cover%20illustration%20of%20a%20magic%20academy%20student%20with%20glowing%20spell%2C%20floating%20crystals%2C%20mystical%20purple%20and%20gold%20color%20scheme%2C%20enchanting%20atmosphere%2C%20clean%20manhwa%20art%20style%2C%20korean%20webtoon%20aesthetic&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '平凡高中生意外进入魔法世界，在异界学院中结识伙伴、修炼魔法、对抗黑暗势力的热血冒险。',
    rating: 4.7,
    views: 1560000,
    chapters: 203,
    status: '连载中',
    updatedAt: '2026-08-07',
    tags: ['奇幻', '魔法', '冒险'],
  },
  {
    id: 4,
    title: '校园风云录',
    author: '郑宇锡',
    category: '校园',
    categorySlug: 'school',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20school%20life%20Korean%20manhwa%20cover%20illustration%20of%20students%20in%20uniform%20walking%20through%20cherry%20blossom%20path%2C%20bright%20spring%20colors%2C%20youthful%20energy%2C%20warm%20sunlight%2C%20clean%20manhwa%20art%20style%2C%20korean%20webtoon%20aesthetic&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '转学生来到新学校，从被孤立到成为校园风云人物的励志成长故事，青春热血与友情的完美交织。',
    rating: 4.6,
    views: 890000,
    chapters: 78,
    status: '已完结',
    updatedAt: '2026-07-20',
    tags: ['校园', '青春', '成长'],
  },
  {
    id: 5,
    title: '重生之商业帝国',
    author: '崔正元',
    category: '剧情',
    categorySlug: 'drama',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20drama%20Korean%20manhwa%20cover%20illustration%20of%20a%20businessman%20in%20luxury%20office%20overlooking%20city%20skyline%2C%20sophisticated%20warm%20tones%2C%20modern%20aesthetic%2C%20clean%20manhwa%20art%20style%2C%20korean%20webtoon%20aesthetic&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '破产商人重生回到二十年前，凭借前世记忆打造商业帝国，复仇与崛起的热血商战漫画。',
    rating: 4.9,
    views: 2100000,
    chapters: 312,
    status: '连载中',
    updatedAt: '2026-08-07',
    tags: ['重生', '商战', '逆袭'],
  },
  {
    id: 6,
    title: '爆笑办公室',
    author: '姜美娜',
    category: '喜剧',
    categorySlug: 'comedy',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20comedy%20Korean%20manhwa%20cover%20illustration%20of%20funny%20office%20workers%20in%20chaotic%20workplace%2C%20bright%20colorful%20style%2C%20humorous%20expressions%2C%20lively%20atmosphere%2C%20clean%20manhwa%20art%20style%2C%20korean%20webtoon%20aesthetic&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '职场菜鸟的爆笑生存指南！奇葩同事、无语老板、搞笑日常，让你笑到停不下来的治愈喜剧。',
    rating: 4.5,
    views: 750000,
    chapters: 45,
    status: '连载中',
    updatedAt: '2026-08-05',
    tags: ['喜剧', '职场', '日常'],
  },
  {
    id: 7,
    title: '幽灵公寓',
    author: '韩志浩',
    category: '恐怖',
    categorySlug: 'horror',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20horror%20Korean%20manhwa%20cover%20illustration%20of%20an%20eerie%20apartment%20building%20at%20night%20with%20mysterious%20shadows%2C%20cold%20dark%20tones%2C%20unsettling%20atmosphere%2C%20clean%20manhwa%20art%20style%2C%20korean%20webtoon%20aesthetic&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '搬进廉价公寓的大学生，发现邻居们一个接一个神秘消失，隐藏在墙壁中的恐怖真相逐渐浮出水面。',
    rating: 4.7,
    views: 620000,
    chapters: 56,
    status: '连载中',
    updatedAt: '2026-08-06',
    tags: ['恐怖', '悬疑', '超自然'],
  },
  {
    id: 8,
    title: '武林至尊',
    author: '金泰亨',
    category: '动作',
    categorySlug: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=An%20action%20Korean%20manhwa%20cover%20illustration%20of%20a%20martial%20arts%20warrior%20in%20dynamic%20fighting%20pose%2C%20dramatic%20ink%20splash%20effects%2C%20powerful%20energy%2C%20warm%20red%20and%20gold%20accents%2C%20clean%20manhwa%20art%20style%2C%20korean%20webtoon%20aesthetic&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '废柴少年偶获武林秘籍，从此踏上成为武林至尊的道路。热血打斗、江湖恩怨，尽在其中。',
    rating: 4.8,
    views: 1350000,
    chapters: 178,
    status: '连载中',
    updatedAt: '2026-08-07',
    tags: ['武侠', '热血', '打斗'],
  },
  {
    id: 9,
    title: '冬日恋歌',
    author: '尹恩惠',
    category: '恋爱',
    categorySlug: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20winter%20Korean%20manhwa%20cover%20illustration%20of%20a%20couple%20in%20snowy%20landscape%2C%20soft%20white%20and%20blue%20tones%2C%20gentle%20snowflakes%2C%20warm%20embrace%2C%20clean%20manhwa%20art%20style%2C%20korean%20webtoon%20aesthetic&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '两个在冬日相遇的灵魂，一段跨越十年的深情守候。唯美画风，虐心剧情，年度最催泪韩漫。',
    rating: 4.9,
    views: 1890000,
    chapters: 120,
    status: '已完结',
    updatedAt: '2026-06-15',
    tags: ['恋爱', '虐心', '唯美'],
  },
  {
    id: 10,
    title: '末日生存法则',
    author: '张民秀',
    category: '悬疑',
    categorySlug: 'thriller',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20post%20apocalyptic%20Korean%20manhwa%20cover%20illustration%20of%20survivors%20in%20ruined%20cityscape%2C%20dramatic%20orange%20and%20gray%20tones%2C%20intense%20survival%20mood%2C%20clean%20manhwa%20art%20style%2C%20korean%20webtoon%20aesthetic&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '末日降临，文明崩塌。一群普通人在废墟中求生的残酷故事，人性与生存的终极考验。',
    rating: 4.6,
    views: 1120000,
    chapters: 67,
    status: '连载中',
    updatedAt: '2026-08-06',
    tags: ['末日', '生存', '人性'],
  },
  {
    id: 11,
    title: '魔王育成计划',
    author: '柳承浩',
    category: '奇幻',
    categorySlug: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20Korean%20manhwa%20cover%20illustration%20of%20a%20demon%20king%20in%20ornate%20armor%20with%20magical%20aura%2C%20gothic%20castle%20background%2C%20deep%20crimson%20and%20black%20tones%2C%20clean%20manhwa%20art%20style%2C%20korean%20webtoon%20aesthetic&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '被选为魔王继承者的普通少年，在光明与黑暗之间挣扎求存，颠覆传统的反套路奇幻巨作。',
    rating: 4.8,
    views: 1780000,
    chapters: 245,
    status: '连载中',
    updatedAt: '2026-08-07',
    tags: ['奇幻', '魔王', '反套路'],
  },
  {
    id: 12,
    title: '那年夏天的约定',
    author: '朴秀珍',
    category: '校园',
    categorySlug: 'school',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20summer%20youth%20Korean%20manhwa%20cover%20illustration%20of%20teenagers%20at%20seaside%20during%20sunset%2C%20nostalgic%20warm%20golden%20light%2C%20bittersweet%20atmosphere%2C%20clean%20manhwa%20art%20style%2C%20korean%20webtoon%20aesthetic&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '高中毕业那年夏天，五个好友许下的约定。十年后，他们各自的人生轨迹又会如何交错？',
    rating: 4.7,
    views: 950000,
    chapters: 88,
    status: '已完结',
    updatedAt: '2026-05-30',
    tags: ['校园', '友情', '成长'],
  },
];

export const rankingComics: Comic[] = [...featuredComics].sort((a, b) => b.views - a.views);

export const latestUpdates: Comic[] = [...featuredComics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());

export const faqData = [
  {
    question: '韩漫大全的漫画都是免费的吗？',
    answer: '是的！韩漫大全平台上的所有漫画均提供免费在线阅读，无需付费订阅。我们致力于为韩漫爱好者提供一个优质的免费阅读平台，让每一位读者都能尽情享受韩国漫画的魅力。',
  },
  {
    question: '韩漫大全的漫画更新频率如何？',
    answer: '我们每日同步更新最新章节，确保读者能在第一时间阅读到喜欢的漫画。通常热门连载漫画每天都会有更新，具体更新频率视原作者的发布节奏而定。',
  },
  {
    question: '可以在手机上阅读韩漫大全吗？',
    answer: '当然可以！韩漫大全完美适配手机、平板和电脑等全平台设备。无论你使用iOS还是Android系统，只需打开浏览器访问我们的网站，即可享受流畅的漫画阅读体验。',
  },
  {
    question: '如何找到我喜欢的类型的漫画？',
    answer: '你可以通过首页的分类导航按类型浏览，也可以使用搜索功能直接搜索漫画名称。我们还提供热门排行榜和编辑推荐，帮助你发现更多优质韩漫。',
  },
  {
    question: '韩漫大全的漫画是正版吗？',
    answer: '韩漫大全平台收录的均为正版授权韩国漫画，我们与多家韩国知名漫画平台和出版社保持合作，确保所有内容的合法合规性，让读者看得安心。',
  },
  {
    question: '可以下载漫画离线阅读吗？',
    answer: '目前韩漫大全支持在线实时阅读，暂不支持下载离线功能。我们建议在Wi-Fi环境下阅读以获得最佳体验，移动数据流量消耗也非常低。',
  },
];

export const testimonials = [
  {
    name: '小雨',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20cute%20anime%20style%20girl%20avatar%20with%20soft%20pink%20background%2C%20minimalist%2C%20clean%20design&width=80&height=80&seq=avatar-01&orientation=squarish',
    comment: '韩漫大全是我每天必刷的网站！更新速度快，画质清晰，种类也特别全。强烈推荐给所有喜欢韩漫的小伙伴！',
    rating: 5,
  },
  {
    name: '星光',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20cool%20anime%20style%20boy%20avatar%20with%20soft%20blue%20background%2C%20minimalist%2C%20clean%20design&width=80&height=80&seq=avatar-02&orientation=squarish',
    comment: '找了好久终于找到一个靠谱的韩漫网站！分类清晰，推荐精准，已经推荐给身边所有朋友了。',
    rating: 5,
  },
  {
    name: '樱花酱',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20sweet%20anime%20style%20girl%20avatar%20with%20soft%20peach%20background%2C%20minimalist%2C%20clean%20design&width=80&height=80&seq=avatar-03&orientation=squarish',
    comment: '恋爱类韩漫真的太甜了！画风精美，剧情在线，每天晚上都要看几话才能睡着。感谢韩漫大全！',
    rating: 5,
  },
];